import React from "react";
import { Link } from "react-router-dom";
import sintomasImg from "../../assets/Page_3&4/Illustration_Doubt.svg"
import ImgVisual from "../../assets/Page_3&4/Icon_1.svg";
import ImgVision from "../../assets/Page_3&4/Icon_2.svg";
import ImgRegilla from "../../assets/Page_3&4/Icon_3.svg";
import ImgColor from "../../assets/Page_3&4/Icon_4.svg";
import ImgRueda from "../../assets/Page_3&4/Icon_5.svg";
import ImgMiopia from "../../assets/Page_3&4/Icon_6.svg";
import CardTest from "../CardTest/CardTest";

import './SectionSintomas.css'

const SectionSintomas = () => {
  const cardsTSintomas = [
    {
      id: 1,
      title: "¿Sientes que ves borroso de lejos (al conducir o ver una película)?",
      img: ImgVisual,
      description:
        "Test para medir la claridad con la que ves objetos lejanos. Es fundamental para detectar posibles problemas como la miopía.",
      btn: "Test de Agudeza Visual",
    },
    {
      id: 2,
      title: "¿Te cuesta leer las letras pequeñas o la pantalla del móvil?",
      img: ImgVision,
      description:
        "Test que evalúa la claridad con la que ves objetos y textos a una distancia de lectura normal. Ideal para adultos mayores de 40 años.",
      btn: "Test de Visión Cercana ",
    },
    {
      id: 3,
      title: "¿Notas líneas onduladas, borrosidad o puntos ciegos?",
      img: ImgRegilla,
      description:
        "Una prueba crucial para detectar cambios en la visión central, lo que podría indicar problemas maculares (la parte central de la retina).",
      btn: "Test de Rejilla de Amsler",
    },
    {
      id: 4,
      title: "¿Confundes colores o tienes dificultades para distinguirlos?",
      img: ImgColor,
      description:
        "Test para identificar deficiencias comunes en la visión del color (dificultad para distinguir entre rojos/verdes o azules/amarillos).",
      btn: "Test de Visión de Color",
    },
    {
      id: 5,
      title: "¿Las líneas horizontales/verticales se ven inclinadas o desenfocadas en ciertas direcciones?",
      img: ImgRueda,
      description:
        "Ayuda a identificar indicios de astigmatismo, una imperfección común en la curvatura del ojo que causa visión borrosa o distorsionada.",
      btn: "Test Rueda de Astigmatismo",
    },
    {
      id: 6,
      title: "Problemas para ver de lejos o de cerca según la situación",
      img: ImgMiopia,
      description:
        "Si algunas cosas se ven claras y otras no según la distancia, esta simulación te permitirá diferenciar la miopía y la hipermetropía.",
      btn: "Miopía vs hipermetropía",
    },
  ];
  return (
    <section className="section-sintomas">
      <h3 className="title-text">Encuentra la Prueba que Necesitas</h3>
      <img src={sintomasImg} alt="page-sintomas" className="img-sintomas"/>
      <p className="description-sintomas">Encuentra el test adecuado según lo que estás sintiendo</p>
      <div className="container-sintomas">
        {cardsTSintomas.map((card) => (
        
          <Link key={card.id} to={`/tests/${card.id}`} className="tests-link">
            <CardTest
              title={card.title}
              paragraph={card.description}
              textButton={card.btn}
              img={card.img}
              key={card.id}
              typeCard="sintomas"
            />
          </Link>
        ))}
      </div>
    </section>
  );
};

export default SectionSintomas;
